/**
 * Doherty Threshold: responses under 400ms feel instantaneous to users.
 * @see https://lawsofux.com/doherty-threshold/
 */
export const SEARCH_DEBOUNCE_MS = 400;
